import React, { Component } from "react";
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import Citation1 from '../Forms/Citation-1'
import SideNavBar from "../SideNavBar";
import { withRouter } from "react-router-dom";

const CitationPage = (props) => {
  console.log(props.location.state);
  return (
   <Citation1/>
  );
};

export default withRouter(NetworkDetector(CitationPage));
